import { useHistory } from "react-router";
import React, { useRef } from "react";
import "./SignUp.css";
import { auth } from "../firebase";
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

function SignUp() {
  const history = useHistory();
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const phoneRef = useRef(null);
  // const passwordRef = useRef(null)
  const register = (e) => {
    e.preventDefault();

    auth
      .createUserWithEmailAndPassword(
        emailRef.current.value,
        phoneRef.current.value
      )

      .then((authUser) => {
        console.log(authUser);
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  return (
    <div className="login">
      <div className="signUpLeft">
        <img src="/sign.gif" alt="" />
      </div>
      <div className="signUpRight">
        <form className="form">

          <label htmlFor="name"></label>
          <input type="text" placeholder="Enter Your Name" ref={nameRef} data-aos="fade-down-right" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true"/>

          <label htmlFor="email"></label>
          <input type="email" placeholder="Enter Your Email" ref={emailRef}
          data-aos="fade-down-right" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-delay="500"  data-aos-once="true"/>

          <label htmlFor="phone"></label>
          <input
            type="phone"
            placeholder="Enter Your Phone Number"
            ref={phoneRef}
            data-aos="fade-down-right" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-delay="1000" data-aos-once="true"
          />

          <label htmlFor="password"></label>
          <input
            type="password"
            placeholder="Set a Password"
            ref={passwordRef}
            data-aos="fade-down-right" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-delay="1500"  data-aos-once="true"
          />

          <button
            onClick={register}
            type="submit"
            onDoubleClick={() => history.push("./home")}
            data-aos="fade-down-right" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-delay="2000" data-aos-once="true"
          >
           SIGN UP
          </button>
        </form>
      </div>
    </div>
  );
}

export default SignUp;
